<template>
  <span v-text="author" />
</template>

<script type="text/babel">
export default {
  name: 'SharedCommunicationAuthorName',
  props: {
    fullName: {
      type: String,
      required: true,
    },
    isASharedCopy: {
      type: Boolean,
      required: false,
      default: false,
    },
    sharingUnionName: {
      type: String,
      required: false,
      default: '',
    },
  },
  computed: {
    author() {
      return this.isASharedCopy
        ? `${this.sharingUnionName} Admin ${this.fullName}`
        : this.fullName
    },
  },
}
</script>
